import React from "react";
import pic from "../rami.jpg";
function about() {
  return (
    <div className="about">
      <img src={pic} alt="my personal" />

      <h2 className="poppins bold">Mohamed Elhefni</h2>
      <p className="flow-text">Coded By React And Github Api</p>
      <p>
        <a
          href="https://www.mohamed-elhefni.ml"
          target="_blank"
          className="center-align content-link"
          rel="noopener noreferrer"
        >
          <i className="material-icons">language</i>
          https://www.mohamed-elhefni.ml
        </a>
      </p>
    </div>
  );
}

export default about;
